export default class TodaysDaf {
    constructor() {
        this.todaysDafLink();
    }
    todaysDafLink(){
        let todays_daf_link = $('.daf_name > a').attr('href');
        if(todays_daf_link){
           let navs =  $('a[href="#get_todays_daf_link"]');

            navs.each(function (){
                $(this).attr('href',todays_daf_link)
            })
        }
    }
}